import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  dashboardButton: {
    display: 'block',
    margin: '0 auto 20px',
    maxWidth: '264px',
    textAlign: 'center',
    backgroundColor: '#036C48',
    color: '#fff'
  }
});
